export default __webpack_public_path__ + "static/media/aws-cp-bg.f1c6d3a2.png";